<template></template>

<script>
export default {
  name: "Company",
};
</script>

<style scoped></style>
